/* Wandlie Stoov-stijl: kruimelpad boven de review + duidelijkere montage-info op de productpagina */
(function () {
  var HOME_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10.5 12 4l8 6.5V19a1.5 1.5 0 0 1-1.5 1.5H15v-5.5a3 3 0 0 0-6 0v5.5H5.5A1.5 1.5 0 0 1 4 19v-8.5Z"/></svg>';

  function isVisible(el) {
    return !!el && el.getClientRects().length > 0;
  }

  function setup(root) {
    var crumbs = root.querySelector('.wd26-breadcrumbs');
    if (!crumbs || crumbs.getAttribute('data-sv-ready') === '1') return;
    crumbs.setAttribute('data-sv-ready', '1');

    var home = crumbs.querySelector('a');
    if (home) {
      var label = (home.textContent || '').trim();
      if (label) home.setAttribute('aria-label', label);
      home.classList.add('sv-crumbs-home');
      home.innerHTML = HOME_ICON;
    }

    var reviews = [
      root.querySelector('.wd26-review-desktop'),
      root.querySelector('.wd26-review-mobile')
    ].filter(Boolean);

    function place() {
      var target = null;
      for (var i = 0; i < reviews.length; i++) {
        if (isVisible(reviews[i])) { target = reviews[i]; break; }
      }
      if (!target) target = reviews[0];
      if (target && target.previousElementSibling !== crumbs) {
        target.parentNode.insertBefore(crumbs, target);
      }
      crumbs.classList.add('sv-crumbs');
    }

    place();
    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(place, 150);
    }, { passive: true });
  }

  var MONTAGE_TEXT = {
    nl: {
      steps: [
        'Kies een stevige stenen of betonnen muur. Bij een holle wand gebruik je bevestigingsmateriaal dat speciaal voor dat type wand bedoeld is.',
        'Controleer met een leidingzoeker of er geen leidingen of kabels lopen op de plek waar je gaat boren.',
        'Bepaal de gewenste werkhoogte, teken de boorgaten af en controleer alles met een waterpas.',
        'Monteer het bureau bij voorkeur met z’n tweeën en volg de meegeleverde montagehandleiding stap voor stap.'
      ],
      link: 'Bekijk de volledige montage-uitleg'
    },
    en: {
      steps: [
        'Choose a solid brick or concrete wall. For a hollow wall, use fixings made specifically for that type of wall.',
        'Use a pipe and cable detector to make sure there are no pipes or wires where you will drill.',
        'Decide on your working height, mark the drill holes and check everything with a spirit level.',
        'Ideally mount the desk with two people and follow the included assembly manual step by step.'
      ],
      link: 'View the full assembly guide'
    },
    de: {
      steps: [
        'Wähle eine stabile Stein- oder Betonwand. Bei einer Hohlwand verwendest du speziell dafür geeignetes Befestigungsmaterial.',
        'Prüfe mit einem Leitungssucher, dass an der Bohrstelle keine Leitungen oder Kabel verlaufen.',
        'Lege die gewünschte Arbeitshöhe fest, markiere die Bohrlöcher und prüfe alles mit einer Wasserwaage.',
        'Montiere den Schreibtisch am besten zu zweit und folge der mitgelieferten Montageanleitung Schritt für Schritt.'
      ],
      link: 'Vollständige Montageanleitung ansehen'
    },
    fr: {
      steps: [
        'Choisissez un mur solide en brique ou en béton. Pour une cloison creuse, utilisez des fixations spécialement prévues pour ce type de mur.',
        'Vérifiez avec un détecteur qu’aucun tuyau ni câble ne passe à l’endroit où vous allez percer.',
        'Déterminez la hauteur de travail, marquez les trous et contrôlez le tout avec un niveau à bulle.',
        'Montez le bureau de préférence à deux et suivez pas à pas la notice de montage fournie.'
      ],
      link: 'Voir le guide de montage complet'
    }
  };

  function setupMontage(root) {
    var montage = root.querySelector('.wd26-montage');
    if (!montage || montage.getAttribute('data-sv-ready') === '1') return;
    montage.setAttribute('data-sv-ready', '1');
    var inner = montage.querySelector('.wd26-montage-inner');
    if (inner) {
      var lang = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
      var t = MONTAGE_TEXT[lang] || MONTAGE_TEXT.en;
      var list = document.createElement('ol');
      list.className = 'sv-montage-steps';
      for (var i = 0; i < t.steps.length; i++) {
        var li = document.createElement('li');
        li.textContent = t.steps[i];
        list.appendChild(li);
      }
      inner.appendChild(list);
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var link = document.createElement('a');
      link.className = 'sv-montage-link';
      link.href = root_url + 'pages/montage';
      link.textContent = t.link + ' →';
      inner.appendChild(link);
    }
    // Standaard opengeklapt zodat de montage-info direct zichtbaar is
    montage.classList.add('open');
    var toggle = montage.querySelector('[data-wd26-montage-toggle]');
    var content = montage.querySelector('.wd26-montage-content');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (content) content.setAttribute('aria-hidden', 'false');
  }

  function init() {
    var roots = document.querySelectorAll('.wd26');
    for (var i = 0; i < roots.length; i++) { setup(roots[i]); setupMontage(roots[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
